import React from 'react';
import { Line } from 'components';
import { I18n } from 'i18n';
import { useSelector } from 'react-redux';
import { hoursByDay } from 'utils';

export default function GraphicGravityFiltersLog(props) {
  const { data, loading } = props;
  const threshold = useSelector(
    ({
      customers: {
        data: {
          thresholds: { pressure },
        },
      },
    }) => pressure,
  );

  return (
    <Line
      loading={loading}
      data={data}
      thresholds={threshold}
      xAccessor="hour"
      yAccessor="value"
      axes={{
        left: {
          tickSize: 4,
          tickPadding: 5,
          tickRotation: 0,
          legend: `${I18n('pressure', true)} [psi]`,
          legendOffset: -40,
          legendPosition: 'middle',
        },
        bottom: {
          tickValues: hoursByDay(60),
          tickSize: 10,
          tickRotation: 90,
          legend: I18n('hour', true),
          legendOffset: 55,
          legendPosition: 'middle',
        },
      }}
    />
  );
}
